import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceInput, required } from "react-admin";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";

const CampaignTypeInput = ({ subTypeId, handleChange, readOnly, ids }) => {
  return (
    <ReferenceInput
      source="typeId"
      filter={subTypeId ? { SubTypeId: subTypeId } : { ids: ids }}
      reference={candidateRequests.getCampaignTypesSelect()}
    >
      <AutoPickSelectInput
        label="Тип"
        source="typeId"
        optionText="name"
        optionValue="id"
        validate={[required()]}
        onChange={handleChange}
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default CampaignTypeInput;
